export const FILE = '/api/v1/files/for-parent';
export const ADD_TEMPORARY_FILE = '/api/v1/files/for-parent/temporary';
export const GET_FILES_IN_ZIP = '/api/v1/files/for-parent/download-zip';
